import axios from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { IWorkingTime } from "@hero/shared/models/workingTime";
import { IDayRangeRequest, IUploadStatusResponse } from "@hero/shared/models/workingTimeUploadDay";
import Url from "../../util/url";
import {
    getWorkingTimeUploadInfoFailed,
    getWorkingTimeUploadInfoSuccess,
    IWorkingTimeUploadAction,
    WorkingTimeUploadTypes,
} from "../actions/workingTimeUpload.action";

const fetchUploadStatus = (range: IDayRangeRequest): Promise<IUploadStatusResponse> =>
    axios.post(Url("working-time-upload/status"), range).then((res) => res.data);

const fetchWorkingTimeRecords = (range: IDayRangeRequest): Promise<IWorkingTime[]> =>
    axios.post(Url("working-time-upload/records"), range).then((res) => res.data);

function* getWorkingTimeUploadSaga(action: IWorkingTimeUploadAction) {
    if (!action.range) {
        yield put(getWorkingTimeUploadInfoFailed("range not found!"));
        return;
    }
    try {
        const [status, records]: [IUploadStatusResponse, IWorkingTime[]] = yield all([
            call(fetchUploadStatus, action.range),
            call(fetchWorkingTimeRecords, action.range),
        ]);
        yield put(getWorkingTimeUploadInfoSuccess(status, records));
    } catch (e) {
        yield put(getWorkingTimeUploadInfoFailed(e));
    }
}

export function* watchWorkingTimeUpload() {
    yield takeLatest(WorkingTimeUploadTypes.GET_WORKING_TIME_UPLOAD, getWorkingTimeUploadSaga);
}
